import React, { Fragment } from "react";
import { RoomCard, RoomCardSkeleton } from "../../components";
import { useSelector } from "react-redux";
import { roomSelector } from "../rooms/roomSlice";

function SelectedRoom({idx}) {
  const { loading, selectedRoom, selectedRooms } = useSelector(roomSelector);
  console.log({selectedRoom});
  console.log({selectedRooms});
  // if (selectedRoom?.length > 0 && loading) return <RoomCardSkeleton />;

  // if (selectedRoom?.length > 0)
  //   return selectedRoom.map((sltdRm, index) => (
  //     <Fragment key={index}>
  //       <RoomCard
  //         isSelectedRoom={true}
  //         uniqueTag={"SELECTED_ROOM_"}
  //         RoomDetails={sltdRm}
  //         index={index}
          
  //       />
  //     </Fragment>
  //   ));

  // console.log({selectedRooms: selectedRooms[idx]} is Object);
  if (selectedRooms?.length > 0 && Object.keys(selectedRooms[idx]).length > 0 && loading) return <RoomCardSkeleton />;

  if (selectedRooms?.length > 0) {
    return selectedRooms.map((sltdRm, index) =>
      Object.keys(sltdRm).length > 0 && index === idx ? (
        <Fragment key={index}>
          <RoomCard
            isSelectedRoom={true}
            uniqueTag="SELECTED_ROOM_"
            RoomDetails={sltdRm}
            index={index}
          />
        </Fragment>
      ) : null
    );
  }
}

export default SelectedRoom;
